import React, { useState } from "react";
import Layout from "../Layout/Layout";
import { UserByMail, isAuthenticated } from "../auth";
import { AddTraductoTeam } from "../auth/apiLanguage";
import { Family } from "../pageInside/Rolle";
import Modal from 'react-bootstrap/Modal';
import { elakayAutoText } from "../pageInside/dataElakay";
import {
  UserPlus,
  Languages,
  CheckCircle2,
  AlertTriangle,
  ShieldCheck,
  Eye,
  Globe2,
} from "lucide-react";

const D = {
  blue: "#3b82f6", blueLt: "#dbeafe",
  green: "#10b981", greenLt: "#d1fae5",
  amber: "#f59e0b", amberLt: "#fef3c7",
  red: "#ef4444", redLt: "#fee2e2",
  txt1: "#0f172a", txt2: "#475569", txt3: "#94a3b8",
  border: "#e2e8f0", bg: "#f8fafc",
  font: "'Inter','Segoe UI',system-ui,-apple-system,sans-serif",
};

const AddTraductorTeam = (props) => {
  const { infoSource } = props;
  const { token } = isAuthenticated();

  const __elakayText = (key, fallback = '') => {
    const val = infoSource?.laguangeElakay?.("frontElakayHardcodedText", infoSource.languageAPI)?.addTraductorTeam?.[key];
    return typeof val === 'string' ? val : fallback;
  };

  const [loading, setLoading] = useState(false);
  const [updat, setUpdat] = useState(false);
  const [selectRole, setSelectRole] = useState("");
  const [email, setEmail] = useState("");
  const [traductorTeam, setTraductorTeam] = useState({
    error: '',
    language: {}
  });

  const allLanguage = [
    { "code": "en", "name": __elakayText("t020", "English"), "nativeName": "English" },
    { "code": "es", "name": __elakayText("t017", "Spanish; Castilian"), "nativeName": "español, castellano" },
    { "code": "ht", "name": __elakayText("t018", "Haitian; Haitian Creole"), "nativeName": "Kreyòl ayisyen" },
    { "code": "fr", "name": __elakayText("t021", "French"), "nativeName": "français, langue française" },
    { "code": "pt", "name": __elakayText("t022", "Portuguese"), "nativeName": "Português" }
  ];

  const { error, language, translator, supervisor, Admin } = traductorTeam;

  const handleEmail = () => event => {
    setEmail(event.target.value);
  };

  const handleChange = () => event => {
    setSelectRole(event.target.value);
  };

  const handlelanguage = () => event => {
    const value = event.target.value;
    let all = allLanguage.filter(l => l.name == value)[0];
    setTraductorTeam({ ...traductorTeam, language: all ? all : {} });
  };

  const addlanguage = (upd) => {
    AddTraductoTeam(token, traductorTeam, upd).then(data => {
      if (data.error) {
        setTraductorTeam({ ...traductorTeam, error: data.error });
      } else {
        setTraductorTeam({
          error: '',
          language: {}
        });
      }
    });
  };

  const showUpdate = error === 'Sorry they are a team in this case';

  const clickEmail = (email, token) => {
    UserByMail(token, email, '', '', Family()).then(data => {
      if (data.error) {
        setTraductorTeam({ ...traductorTeam, error: data.error });
      } else {
        setEmail("");
        setSelectRole("");
        setTraductorTeam({
          ...traductorTeam,
          error: '',
          [selectRole]: {
            email: data.user.email,
            user: data.user._id,
            name: data.user.firstname + ' ' + data.user.lastname
          }
        });
      }
    });
  };

  let l = language && language.name ? true : false;
  let t = translator && translator.user ? true : false;
  let s = supervisor && supervisor.user ? true : false;
  let A = Admin && Admin.user ? true : false;
  let LAST = t || s || A || l;
  let ast = t || s || A;
  let last = ast && l;

  const clickEditAdd = (chek) => {
    if (!chek) {
      setUpdat(false);
      setTraductorTeam({ ...traductorTeam, error: "" });
    } else {
      setUpdat(true);
    }
  };

  // ─── Shared primitives ───────────────────────────────────────────────────
  const showError = () => !error ? null : (
    <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "10px 14px", background: D.redLt, borderRadius: 8, border: "1px solid #fca5a5", marginBottom: 12 }}>
      <AlertTriangle size={16} color="#991b1b" style={{ flexShrink: 0 }} />
      <span style={{ fontSize: 12, color: "#991b1b", fontWeight: 500 }}>{error}</span>
    </div>
  );

  const fieldLabelStyle = { display: "block", fontSize: 11, fontWeight: 700, color: D.txt3, textTransform: "uppercase", letterSpacing: .6, marginBottom: 6 };
  const selectStyle = { width: "100%", padding: "9px 12px", borderRadius: 8, border: `1px solid ${D.border}`, fontSize: 13, color: D.txt1, background: "#fff", outline: "none", cursor: "pointer", fontFamily: D.font, boxSizing: "border-box" };
  const inputStyle = { ...selectStyle, cursor: "text" };

  const Card = ({ icon, title, children }) => (
    <div style={{ background: "#fff", border: `1px solid ${D.border}`, borderRadius: 12, padding: "18px 20px", marginBottom: 16 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 14 }}>
        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 26, height: 26, borderRadius: 8, background: D.blueLt, color: D.blue, flexShrink: 0 }}>
          {icon}
        </span>
        <h3 style={{ fontSize: 13, fontWeight: 700, color: D.txt2, margin: 0 }}>{title}</h3>
      </div>
      {children}
    </div>
  );

  // ─── Step 1 : language ───────────────────────────────────────────────────
  const LanguageSeleted = () => (
    <div onBlur={() => setTraductorTeam({ ...traductorTeam, error: "" })}>
      <label style={fieldLabelStyle}>{infoSource.language(infoSource, "label", "seltyUser")}</label>
      <select onChange={handlelanguage()} style={selectStyle} value={language.name ? language.name : ''}>
        <option value=''>{infoSource.language(infoSource, "label", "ChoLang")}</option>
        {allLanguage?.map((l, i) => <option key={i} value={l.name}>{l.name}</option>)}
      </select>
    </div>
  );

  // ─── Step 2 : role + email lookup ───────────────────────────────────────
  const userSeleted = () => (
    <div onBlur={() => setTraductorTeam({ ...traductorTeam, error: "" })}>
      <label style={fieldLabelStyle}>{infoSource.language(infoSource, "label", "seltyUser")}</label>
      <select onChange={handleChange()} style={selectStyle} value={selectRole}>
        <option value={""}>{__elakayText("t019", "Choose type of your user")}</option>
        <option value={elakayAutoText("h_2e47fc71395d54", "translator")}>{__elakayText("t005", "translator")}</option>
        <option value={elakayAutoText("h_0f4d09e43d208d", "supervisor")}>{__elakayText("t008", "supervisor")}</option>
        <option value={elakayAutoText("h_4e7afebcfbae00", "Admin")}>{__elakayText("t011", "Admin")}</option>
      </select>
    </div>
  );

  const CheckUser = () => (
    <div style={{ marginTop: 14 }} onBlur={() => setTraductorTeam({ ...traductorTeam, error: "" })}>
      {showError()}
      <label style={fieldLabelStyle}>
        {infoSource.language(infoSource, "label", "cheUser")} {selectRole} {infoSource.language(infoSource, "label", "ifExit")}
      </label>
      <div style={{ display: "flex", gap: 10 }}>
        <input
          onChange={handleEmail()}
          type="text"
          style={{ ...inputStyle, flex: 1 }}
          placeholder={elakayAutoText("h_c63e8fbd3b044b", "enter the email for {value0}", { value0: selectRole })}
          value={email}
        />
        <button
          onClick={() => clickEmail(email, token)}
          disabled={!(selectRole && email)}
          style={{
            padding: "9px 18px", borderRadius: 8, border: "none", fontSize: 13, fontWeight: 600,
            fontFamily: D.font, whiteSpace: "nowrap",
            cursor: selectRole && email ? "pointer" : "not-allowed",
            background: selectRole && email ? D.blue : "#cbd5e1",
            color: selectRole && email ? "#fff" : "#94a3b8",
          }}
        >
          {infoSource.language(infoSource, "Button", "checkEmail")}
        </button>
      </div>
    </div>
  );

  // ─── Status banner ───────────────────────────────────────────────────────
  const addDIv = (e, a, b = false, c) => {
    const isWarning = e.includes('warning');
    return (
      <div style={{
        display: "flex", alignItems: "flex-start", gap: 10, padding: "14px 16px",
        borderRadius: 10, marginBottom: 16,
        background: isWarning ? D.amberLt : D.blueLt,
        border: `1px solid ${isWarning ? "#fde68a" : "#bfdbfe"}`,
      }}>
        {isWarning
          ? <AlertTriangle size={18} color="#92400e" style={{ flexShrink: 0, marginTop: 1 }} />
          : <CheckCircle2 size={18} color={D.blue} style={{ flexShrink: 0, marginTop: 1 }} />}
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: isWarning ? "#92400e" : D.txt1 }}>
            {infoSource.language(infoSource, "title", "yadd")}{a}
          </div>
          {b && (
            <div style={{ fontSize: 12, color: isWarning ? "#92400e" : D.txt2, marginTop: 4 }}>
              {infoSource.language(infoSource, "title", "dwadd")}{c}
            </div>
          )}
        </div>
      </div>
    );
  };

  const typeUserAdding = () =>
    A && s && t ? addDIv("alert alert-primary", ' a translator, Supervisor and Admin', false, '') :
    t && s ? addDIv("alert alert-primary", 'a translator and supervisor', true, ' a Admin') :
    A && s ? addDIv("alert alert-primary", 'a Admin and supervisor', true, ' a translator') :
    A && t ? addDIv("alert alert-primary", 'a Admin and translator', true, ' a supervisor') :
    t ? addDIv("alert alert-primary", 'a translator', true, ' a Supervisor and Admin') :
    s ? addDIv("alert alert-primary", 'a Supervisor', true, ' a translator and Admin') :
    A ? addDIv("alert alert-primary", 'a Admin', true, ' a Supervisor and translator') :
    addDIv("alert alert-warning", 'noboby ', true, ' a translator,a Supervisor and Admin');

  // ─── Summary + submit ────────────────────────────────────────────────────
  const SummaryRow = ({ label, value }) => (
    <div style={{ display: "flex", fontSize: 13, padding: "3px 0" }}>
      <span style={{ color: D.txt3, minWidth: 150 }}>{label}</span>
      <span style={{ color: D.txt1, fontWeight: 600 }}>{value}</span>
    </div>
  );

  const SummarySection = ({ icon, title, children }) => (
    <div style={{ padding: "14px 18px", borderBottom: `1px solid ${D.border}` }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8 }}>
        <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 22, height: 22, borderRadius: 6, background: D.greenLt, color: D.green, flexShrink: 0 }}>
          {icon}
        </span>
        <h4 style={{ fontSize: 12, fontWeight: 700, color: D.txt2, margin: 0, textTransform: "uppercase", letterSpacing: .5 }}>{title}</h4>
      </div>
      {children}
    </div>
  );

  const addLang = () => {
    const text = infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addTraductorTeam;
    return (
      <div style={{ background: "#fff", border: `1px solid ${D.border}`, borderRadius: 12, marginBottom: 16, overflow: "hidden" }}>
        {l && (
          <SummarySection icon={<Globe2 size={13} />} title={text.t001}>
            <SummaryRow label={text.t002} value={language.code} />
            <SummaryRow label={text.t003} value={language.name} />
            <SummaryRow label={text.t004} value={language.nativeName} />
          </SummarySection>
        )}
        {t && translator.email && (
          <SummarySection icon={<Languages size={13} />} title={text.t005}>
            <SummaryRow label={text.t006} value={translator.email} />
            <SummaryRow label={text.t007} value={translator.name} />
          </SummarySection>
        )}
        {s && supervisor.email && (
          <SummarySection icon={<Eye size={13} />} title={text.t008}>
            <SummaryRow label={text.t009} value={supervisor.email} />
            <SummaryRow label={text.t010} value={supervisor.name} />
          </SummarySection>
        )}
        {A && Admin.email && (
          <SummarySection icon={<ShieldCheck size={13} />} title={text.t011}>
            <SummaryRow label={text.t012} value={Admin.email} />
            <SummaryRow label={text.t013} value={Admin.name} />
          </SummarySection>
        )}
        <div style={{ padding: "14px 18px", display: "flex", justifyContent: "flex-end" }}>
          <button
            onClick={last ? () => addlanguage(false) : undefined}
            disabled={!last}
            style={{
              padding: "9px 20px", borderRadius: 8, border: "none", fontSize: 13, fontWeight: 600,
              fontFamily: D.font, cursor: last ? "pointer" : "not-allowed",
              background: last ? D.green : "#cbd5e1", color: last ? "#fff" : "#94a3b8",
            }}
          >
            {infoSource.language(infoSource, 'Button', "submit")}
          </button>
        </div>
      </div>
    );
  };

  // ─── Confirm-update modal ────────────────────────────────────────────────
  const agreeUpdate = () => {
    const text = infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addTraductorTeam;
    return (
      <Modal
        size="lg"
        show={showUpdate}
        onHide={() => clickEditAdd(false)}
        centered
        aria-labelledby="agree-update-title"
      >
        <Modal.Header closeButton style={{ background: D.bg, borderBottom: `1px solid ${D.border}`, fontFamily: D.font }}>
          <Modal.Title id="agree-update-title" style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 34, height: 34, borderRadius: 10, background: D.amberLt, color: "#92400e", flexShrink: 0 }}>
              <AlertTriangle size={17} />
            </span>
            <span style={{ fontSize: 15, fontWeight: 700, color: D.txt1 }}>
              {infoSource.language(infoSource, 'title', "sureUpteamLang")}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontFamily: D.font, background: D.bg }}>
          {showError()}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <button
              type="button"
              onClick={() => clickEditAdd(false)}
              style={{
                padding: 14, borderRadius: 10, cursor: "pointer", textAlign: "left", fontFamily: D.font,
                border: `2px solid ${!updat ? D.blue : D.border}`,
                background: !updat ? D.blueLt : "#fff",
              }}
            >
              <div style={{ fontSize: 13, fontWeight: 700, color: D.txt1 }}>{text.t014}</div>
            </button>
            <button
              type="button"
              onClick={() => clickEditAdd(true)}
              style={{
                padding: 14, borderRadius: 10, cursor: "pointer", textAlign: "left", fontFamily: D.font,
                border: `2px solid ${updat ? D.blue : D.border}`,
                background: updat ? D.blueLt : "#fff",
              }}
            >
              <div style={{ fontSize: 13, fontWeight: 700, color: D.txt1 }}>{text.t015}</div>
            </button>
          </div>
        </Modal.Body>
        <Modal.Footer style={{ background: D.bg, borderTop: `1px solid ${D.border}`, fontFamily: D.font }}>
          <button
            onClick={updat ? () => addlanguage(true) : undefined}
            disabled={!updat}
            style={{
              padding: "9px 20px", borderRadius: 8, border: "none", fontSize: 13, fontWeight: 600,
              fontFamily: D.font, cursor: updat ? "pointer" : "not-allowed",
              background: updat ? D.blue : "#cbd5e1", color: updat ? "#fff" : "#94a3b8",
            }}
          >
            {infoSource.language(infoSource, 'Button', "submit")}
          </button>
        </Modal.Footer>
      </Modal>
    );
  };

  // ─── Page ────────────────────────────────────────────────────────────────
  return (
    <Layout
      infoSource={infoSource}
      title={infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addTraductorTeam.t016}
      description={elakayAutoText("h_41682905073222", "Node React E-commerce App")}
      className="container"
      loading={loading}
      SliderPunShow={false}
      {...infoSource?.allSettings?.layout}
    >
      <div style={infoSource.styleNav}>
        <div style={{ maxWidth: 880, margin: "0 auto", padding: "24px 20px", fontFamily: D.font }}>

          <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
            <span style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 40, height: 40, borderRadius: 12, background: D.blueLt, color: D.blue, flexShrink: 0 }}>
              <UserPlus size={20} />
            </span>
            <h1 style={{ fontSize: 19, fontWeight: 700, color: D.txt1, margin: 0 }}>
              {infoSource.laguangeElakay("frontElakayHardcodedText", infoSource.languageAPI).addTraductorTeam.t016}
            </h1>
          </div>

          <Card icon={<Globe2 size={14} />} title={elakayAutoText("h_7c4a8e2f9b1d36", "Langue à traduire")}>
            {LanguageSeleted()}
          </Card>

          <Card icon={<UserPlus size={14} />} title={elakayAutoText("h_3d9f6a1c7e2b48", "Ajouter un membre de l'équipe")}>
            {userSeleted()}
            {CheckUser()}
          </Card>

          {typeUserAdding()}
          {LAST && addLang()}
          {agreeUpdate()}
        </div>
      </div>
    </Layout>
  );
};

export default AddTraductorTeam;
